(() => {
  const summaries = new Set();
  let resizeTimer = null;

  const measureNeedsToggle = (summary, text) => {
    const wasExpanded = summary.classList.contains('is-expanded');

    text.classList.remove('is-collapsed');
    const fullHeight = Math.ceil(text.getBoundingClientRect().height);

    text.classList.add('is-collapsed');
    const collapsedHeight = Math.ceil(text.getBoundingClientRect().height);

    if (wasExpanded) text.classList.remove('is-collapsed');

    return fullHeight > collapsedHeight + 1;
  };

  const refreshSummary = (summary) => {
    const text = summary.querySelector('[data-fa-product-summary-text]');
    const button = summary.querySelector('[data-fa-product-summary-toggle]');
    const label = summary.querySelector('[data-fa-product-summary-label]');
    if (!text || !button || !label) return;

    const needsToggle = measureNeedsToggle(summary, text);
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    if (!needsToggle) {
      button.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      summary.classList.remove('is-expanded');
      text.classList.remove('is-collapsed');
      label.textContent = 'Read more';
      return;
    }

    button.hidden = false;

    if (isExpanded) {
      summary.classList.add('is-expanded');
      text.classList.remove('is-collapsed');
      label.textContent = 'Read less';
    } else {
      summary.classList.remove('is-expanded');
      text.classList.add('is-collapsed');
      label.textContent = 'Read more';
    }
  };

  const initProductSummaries = (root = document) => {
    root.querySelectorAll('[data-fa-product-summary-collapsible]').forEach((summary) => {
      const text = summary.querySelector('[data-fa-product-summary-text]');
      const button = summary.querySelector('[data-fa-product-summary-toggle]');
      const label = summary.querySelector('[data-fa-product-summary-label]');
      if (!text || !button || !label) return;

      summaries.add(summary);

      if (summary.dataset.faProductSummaryReady !== 'true') {
        summary.dataset.faProductSummaryReady = 'true';

        button.addEventListener('click', () => {
          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          const willExpand = !isExpanded;

          button.setAttribute('aria-expanded', String(willExpand));
          summary.classList.toggle('is-expanded', willExpand);
          text.classList.toggle('is-collapsed', !willExpand);
          label.textContent = willExpand ? 'Read less' : 'Read more';
        });
      }

      requestAnimationFrame(() => refreshSummary(summary));
    });
  };

  const refreshAll = () => {
    summaries.forEach((summary) => {
      if (summary.isConnected) refreshSummary(summary);
      else summaries.delete(summary);
    });
  };

  const start = () => {
    initProductSummaries();

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => requestAnimationFrame(refreshAll));
    }

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refreshAll, 120);
    }, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initProductSummaries(event.target);
  });
})();
